module.exports = __webpack_public_path__ + "img/1.7025ec42.png";